<template>
  <v-container v-if="!$store.state.globalLoading" class="px-0">

    <!-- HEADING -->
    <div v-if="initialLoad">
      <div>
        <v-layout justify-center >
          <v-flex xs12 sm10 md8 lg6 xl4>
            <v-layout>
              <v-flex xs2>
                <v-btn class="ml-3" text dark color="orange" @click="$router.push({name: 'Home'})"> < Home</v-btn>
              </v-flex>
              <v-flex xs10>
                <div
                  class="assess text-center "
                  v-if="stage == 'assess' || stage == 'learn' || stage == 'review'"
                  >
                    <span class="blue--text" v-if="stage=='assess'">Assess</span>
                    <span class="orange--text" v-if="stage=='learn'">Learn</span>
                    <span class="purple--text" v-if="stage=='review'">Review</span>
                    <div>
                      <span v-if="stage == 'assess'" class="blue--text title">{{learningState.assess.length}}</span>
                      <span v-if="stage != 'assess'">{{learningState.assess.length}}</span> |

                      <span v-if="stage == 'learn'" class="orange--text title">{{learningState.learn.length}}</span>
                      <span v-if="stage != 'learn'">{{learningState.learn.length}}</span> |

                      <span v-if="stage == 'review'" class="purple--text title">{{learningState.review.length}}</span>
                      <span v-if="stage != 'review'">{{learningState.review.length}}</span> |

                      <span>{{learningState.know.length}}</span>
                    </div>
                </div>
              </v-flex>
              <v-flex xs2>
                <v-btn text color="grey" v-if="!showKnowledgeButtons && lastAction.length > 0 && (stage == 'assess' || stage == 'learn' || stage == 'review')" @click="undoLastCard()">
                  <v-icon>mdi-undo</v-icon>
                  Undo
                </v-btn>
              </v-flex>
            </v-layout>

          </v-flex>
        </v-layout>
      </div>

      <!-- RESTORE PREVIOUS PRACTICE -->
      <v-layout justify-center v-if="stage == 'restore'">
        <v-flex xs12 sm10 md8 lg6 xl4>
          <v-card flat outlined class="round-card text-center ma-5 pa-5" >
            <div class="purple--text overline font-weight-regular">{{deckDetails.subject}}</div>
            <div class="purple--text title font-weight-regular">{{deckDetails.name}}</div>
            <div class="mt-3">
              You have an unfinished session for this deck. <span v-if="disableRestore" class="blue--text"> However, we made some changes since your last session and need to reset your progress.</span>
            </div>
            <v-btn rounded dark class="ma-3" v-if="!disableRestore" color="purple" @click="restoreSessionStart()">Resume</v-btn>
            <v-btn rounded dark class="ma-3" color="blue" @click="newSessionSetup()">Restart</v-btn>
          </v-card>
        </v-flex>
      </v-layout>

      <!-- SETUP CURRENT SESSION -->
      <v-layout justify-center v-if="stage == 'setup'">
        <v-flex xs12 sm10 md8 lg6 xl4>
          <v-card flat outlined class="round-card text-center ma-5 pa-5" >
            <div class="blue--text overline font-weight-regular">{{deckDetails.subject}}</div>
            <div class="blue--text title font-weight-regular">{{deckDetails.name}}</div>
            <p class="mt-5">
              How well do you think you know this material?
            </p>
            <Rating @ratingSet="recordInitialConfidence"/>
            </v-slider>
            <v-btn class="ma-5" v-if="deckMetrics.metrics.initialConfidence == null" rounded disabled @click="newSessionStart()">Study</v-btn>
            <v-btn class="ma-5" v-if="deckMetrics.metrics.initialConfidence != null" rounded color="blue" dark @click="newSessionStart()">Study</v-btn>
          </v-card>
        </v-flex>
      </v-layout>

      <!-- LEARNING SESSION -->
      <div id="learning-content" v-if="stage == 'assess' || stage == 'learn' || stage == 'review'">
        <v-layout justify-center>
          <v-flex xs12 sm10 md8 lg6 xl4>
            <v-progress-linear v-model="progressBarProgress" :color="progressBarColor"  height="5"></v-progress-linear>
          </v-flex>
        </v-layout>
        <cardQuestionAnswer v-if="content[currentCard].type == 'question_answer'" :card="content[currentCard]" @answerState="setAnswerState" @hotkey="respondToHotkey" :key="rerenderCounter"/>
        <cardLabeledImage v-if="content[currentCard].type == 'labeled_image'" :card="content[currentCard]" @answerState="setAnswerState" @hotkey="respondToHotkey" :key="rerenderCounter"/>
      </div>





      <div id="" fixed v-if="showKnowledgeButtons && stage != 'complete'">
        <v-layout>
          <v-flex xs12 class="text-center">
            <v-btn @click="processResult(false)" class="ma-3"  x-large dark color="purple"><v-icon x-large>mdi-thumb-down</v-icon></v-btn>
            <v-btn @click="processResult(true)" class="ma-3" x-large dark color="blue"><v-icon x-large>mdi-thumb-up</v-icon></v-btn>
          </v-flex>
        </v-layout>
      </div>

      <div v-if="stage == 'assess' || stage == 'learn' || stage == 'review'">
        <v-layout justify-center>
          <v-flex xs6 sm5 md4 lg3 xl2>
            <div class="text-left mt-5 ml-3">
              <a small outlined style="text:grey;" @click="reportProblem()">Report Problem</a>
            </div>
          </v-flex>
          <v-flex xs6 sm6 md5 lg4 xl2>
            <div v-if="stage == 'review'" class="text-right mt-5 mr-3">
              <v-btn small outlined color="purple" @click="skipReview()">Skip Review ></v-btn>
            </div>
          </v-flex>
        </v-layout>
      </div>












      <!-- SUMMARY PAGE -->
      <div v-if="stage == 'complete'">
        <v-card flat class="round-card text-center">
          <div class="headline blue--text m5-5 mb-3">Deck Summary</div>

          <v-layout justify-center wrap>
            <v-flex xs6 sm4 md2>
              <v-card outlined flat class="pa-3 ma-1">
                <div class="overline">Total Cards</div>
                <div class="display-1 blue--text">{{deckMetrics.metrics.totalCards}}</div>
              </v-card>

            </v-flex>
            <v-flex xs6 sm4 md2>
              <v-card outlined flat class="pa-3 ma-1">
                <div class="overline"> Time Studying</div>
                <div class="display-1 blue--text">{{UItotalTimeSpent(deckMetrics.metrics.totalTimeSeconds)}}</div>
              </v-card>
            </v-flex>
            <!-- <v-flex xs12 sm4 md2>
              <v-card outlined flat class="pa-3 ma-1">
                <div class="overline">Suggested Study Again</div>
                <div class="display-1 blue--text">XX</div>
              </v-card>
            </v-flex> -->
          </v-layout>
          <!-- <div class="headline purple--text mt-5 mb-3">Hard Cards</div>

          <v-card class="text-left pa-1" v-for="(card, x) in countNumberOfTimesByCard" :key="x" flat>
              <cardQuestionAnswer ref="cardQA" class="pa-3" :card="content[card]" />
          </v-card>
          <p v-if="countNumberOfTimesByCard.length < 1">
            <div>Well done, you had no particularly challenging cards!</div>

          </p> -->
          <v-btn class="mt-3" dark rounded color="blue" @click="$router.push({name:'Home'})">Return Home</v-btn>

        </v-card>
      </div>
    </div>

    <ReportProblem ref="problem"/>


  </v-container>
</template>

<script>
import Obj from '@/objects'
import cardQuestionAnswer from '@/components/cardQuestionAnswer.vue'
import cardLabeledImage from '@/components/cardLabeledImage.vue'
import ReportProblem from '@/components/ReportProblem.vue'
import firebase from 'firebase'
import uuid from 'uuid/v4'
import _ from 'underscore'
import moment from 'moment'
import Rating from '@/components/Rating.vue'
import OMetrics from '@/OMetrics'

export default {
  name: 'Learn',
  components: {
    Rating,
    cardQuestionAnswer,
    cardLabeledImage,
    ReportProblem
  },
  data() {
    return {
      initialLoad: false,
      deckId: this.$route.params.id,
      deckDetails: null,
      previousHistory: null,

      stage:'', //
      stages: [
        'restore',
        'setup',
        'assess',
        'learn',
        'review',
        'complete'
      ],
      learningState: {
        assess: [],
        learn: [],
        review: [],
        know: []
      },
      lastAction: [],
      content: null,
      showKnowledgeButtons: false,
      loading: false,
      sessionId: uuid(),
      showAnswer: false,
      deckMetrics: null,
      cardMetrics: null,
      rerenderCounter: 0,
      disableRestore: false, //UI toggled controlled by checkIfChangeInContent()
    }
  },
  computed: {
    // answerButtonBarFloating() {
    //   console.log(document.body.scrollHeight > window.innerHeight)
    //   return document.body.scrollHeight > window.innerHeight
    // },
    progressBarProgress() {
      let totalCards = Object.keys(this.content).length
      let minAnswer = totalCards * 2
      let a = totalCards - this.learningState.assess.length
      let l = this.deckMetrics.metrics.assessFalse - this.learningState.learn.length
      let r = this.learningState.know.length
      let denom = minAnswer + this.deckMetrics.metrics.assessFalse
      let num = a + l + r
      return Math.round((num/denom) * 100)
    },
    progressBarColor(){
      switch(this.stage) {
        case 'assess':
          return 'blue'
        case 'learn':
          return 'orange'
        case 'review':
          return 'purple'
        default:
          return 'grey'
      }
    },
    currentCard() {
      switch(this.stage) {
        case 'assess':
          return this.learningState['assess'][0]
        case 'learn':
          return this.learningState['learn'][0]
        case 'review':
          return this.learningState['review'][0]
        default:
          return {question:"", answer:""}
      }
    },

    //Post Quiz Metrics
    countNumberOfTimesByCard() {
      var grouped = _.groupBy(this.deckMetrics.metrics.answerHistory, 'contentId');
      var count = _.mapObject(grouped, function(items) {
        return items.length;
      });


      let final = []
      for (var x in count) {
        if (count[x] >= 4) {
          final.push(x)
        }
      }
      return final
    },

  },

  mounted() {
    this.initializeContent()

  },
  methods: {
    initializeContent() {
      this.$store.commit('globalLoadingSet', true)
      Promise.all([
        this.getDeckContent(),
        this.getDeckHistory()
      ]).then(() => {
        let valid = this.checkIfValidDomain()
        if (!valid) {
          throw 'Your account cannot access this content.'

        } else {
          return 'valid'
        }
      }).then(() => {
        let subscribed = this.checkIfSubscribed()
        if (!subscribed && this.deckDetails.public == true) {
          //add to subscribe decks
          firebase.firestore().collection('users')
          .doc(firebase.auth().currentUser.uid)
          .update({subscribedDecks: firebase.firestore.FieldValue.arrayUnion(this.deckId)})
          //display confirmation message
          this.$store.commit('snackbarMessageSet', {
            color: 'blue lighten-2',
            message: 'Subscribed to deck.'
          })

        }
      }).then(() => {
        this.initialLoad = true
        this.$store.commit('globalLoadingSet', false)
        //if previous session exists, fill in data
        if (this.previousHistory != null) {
            if (this.previousHistory.currentSession != null) {

              this.restoreSessionSetup()
            }
            //else setup new session
            else {
              this.newSessionSetup()
            }
        }
        else {
          this.newSessionSetup()
        }
      }).catch(err => {
        this.$store.commit('snackbarMessageSet', {
          color: 'red lighten-2',
          message: err
        })
        setTimeout(() => {
          this.$store.commit('globalLoadingSet', false)
          this.$router.push({name: 'Home'})
        }, 2000);
      })
    },
    checkIfValidDomain() {
      if (this.deckDetails.domainAuth.length > 0 ) { //ensure domain authorization is needed
        return _.intersection(this.deckDetails.domainAuth, this.$store.state.userData.domainAuth).length > 0
      }
      else {
        return true
      }

    },
    checkIfSubscribed() {
      return this.$store.state.userData.subscribedDecks.includes(this.deckId)

    },
    //Data METHODS
    getDeckContent() {
      return firebase.firestore().collection('deckPackages')
      .doc(this.deckId).get()
      .then(doc => {
        if (doc.exists) {
          let data = doc.data()
          //sort array into object
          this.content = {}
          data.cards.forEach(entry => {
            if (entry.type == 'question_answer') {
              let contentId = entry.id + '-1'
              entry.contentId = contentId
              this.content[contentId] = entry
            }
            else if (entry.type = 'labeled_image') {
              entry.entries.forEach(i => {
                let specificContent = Object.assign({}, entry)
                delete specificContent.entries
                specificContent.entry = i
                let contentId = entry.id + '-' + i.label
                specificContent.contentId = contentId
                this.content[contentId] = specificContent
              })
            }
          })
          this.deckDetails = data.deckDetails
          return 'done'
        }
        else {
          throw "This deck is not published."
        }
      })
    },
    getDeckHistory() {
      return firebase.firestore().collection('learningRecord')
      .doc(firebase.auth().currentUser.uid)
      .collection('deckRecord')
      .doc(this.deckId).get()
      .then(doc => {
        //check to see if previous practice record
        if (doc.exists) {
          this.previousHistory = doc.data()
        }
      })
    },
    //INITAL METHODS
    //NEW SESSION
    newSessionSetup(){
      this.deckMetrics = OMetrics.createDeckMetrics(this.deckId)
      this.learningState = this.newLearningState()
      this.stage = 'setup'
    },
    recordInitialConfidence(val) {
      this.deckMetrics.recordInitialConfidence(val)
    },
    newSessionStart(){
      this.learningState.assess = _.shuffle(Object.keys(this.content))

      //must set stage before calling this.currentCard
      this.setStage()
      this.cardMetrics = OMetrics.createCardMetrics(this.content[this.currentCard])


    },
    //RESTORING SESSION

    //Used to check if we have added or deleted cards since the last session.
    checkIfChangeInContent() {
      let lastSession = Object.values(this.previousHistory.currentSession.learningState).flat()
      let currentSession = Object.keys(this.content)
      //must check the diff both ways
      let delta = _.difference(lastSession,currentSession).length + _.difference(currentSession, lastSession).length
      console.log(delta)
      if (delta > 0) {
        this.disableRestore = true // UI toggle
      }

    },
    restoreSessionSetup(){
      this.stage = 'restore'
      this.checkIfChangeInContent()
    },
    restoreSessionStart(){
      this.deckMetrics = OMetrics.createDeckMetrics(this.deckId)
      this.deckMetrics.restoreDataFromLastSession(this.previousHistory.currentSession.deckMetrics)

      this.learningState = this.previousHistory.currentSession.learningState
      //must set stage before calling this.currentCard
      this.setStage()
      this.cardMetrics = OMetrics.createCardMetrics(this.content[this.currentCard])

    },


    //ANSWER CONTROLS
    setAnswerState(answerState) {
      this.cardMetrics.recordFlip()
      this.showKnowledgeButtons = answerState
    },
    respondToHotkey(val) {
      if (val == 1) {
        this.processResult(false)
      }
      else if (val == 3) {
        this.processResult(true)
      }
      else if (val == 'z' && this.lastAction.length > 0) {
        this.undoLastCard()
        console.log('z')

      }

      // switch(val) {
      //   case 1:
      //     return this.processResult(false)
      //   case 3:
      //     return this.processResult(true)
      //   case 'z':
      //     if (this.lastAction.length > 0) {
      //       return this.undoLastCard()
      //     }
      //   default:
      //     return null
      // }
    },

    processResult(value) {
      //used to advance cards, store last action, and count stats


      //reset window position
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

      //record card response
      this.cardMetrics.recordCardResult(this.stage, value)
      this.cardMetrics.DBrecordCardState(this.deckId)

      //SPECIAL FUNCTION TO RECORD DAILY PRACTICE METRICS
      this.DBlogPracticeProgress(this.cardMetrics.metrics.totalTimeSeconds)

      if (this.stage == 'assess') {
        if (value) {
          this.deckMetrics.incrementAssessTrue()
        }
        else {
          this.deckMetrics.incrementAssessFalse()
        }
      }
      this.moveCard(value)
      this.setStage()

      this.deckMetrics.recordAnswerHistory(this.cardMetrics.metrics)

      if (this.stage == 'complete') {
        this.deckMetrics.calculateCompletionMetrics()
        this.deckMetrics.DBrecordDeckTermination(this.learningState)
      }
      else {
        this.deckMetrics.DBrecordDeckState(this.learningState)
      }



      //general logging
      this.DBlogCardActivity()

      //rerender card for single card transition
      this.rerenderCounter += 1
      this.showKnowledgeButtons = false

      //get next card
      this.cardMetrics = OMetrics.createCardMetrics(this.content[this.currentCard])

    },

    undoLastCard() {

      //Remove from answer history locally and get card ID
      let lastCard = this.deckMetrics.metrics.answerHistory.pop()
      let id = lastCard.contentId.split("-")[0]

      //If in the assess stage adjust the scores
      if (lastCard.stage == 'assess') {
        if (lastCard.result) {
          this.deckMetrics.decrementAssessTrue()
        }
        else {
          this.deckMetrics.decrementAssessFalse()
        }
      }

      let localLastAction = this.lastAction.pop()
      //Reverse the movement of the card
      this.learningState[localLastAction.from].unshift(
        this.learningState[localLastAction.to].pop()
      )
      //adjust stage
      this.setStage()

      //Clear the card history
      firebase.firestore().collection('learningRecord')
      .doc(firebase.auth().currentUser.uid)
      .collection('cardRecord')
      .doc(id).update({
          history: firebase.firestore.FieldValue.arrayRemove(lastCard)
      });

      //Save the state of the deck
      this.deckMetrics.DBrecordDeckState(this.learningState)

      //Prepare new card metrics.
      this.cardMetrics = OMetrics.createCardMetrics(this.content[this.currentCard])

      //Show answer for last question
      this.showKnowledgeButtons = false
    },

    moveCard(value) {
      let buckets = ['assess', 'learn', 'review', 'know']
      let i = buckets.indexOf(this.stage)
      let card = this.learningState[buckets[i]].shift()
      if (this.stage == 'assess') {
        if (value) {
          this.learningState[buckets[i+2]].push(card)
          this.lastAction.push({
            to: buckets[i+2],
            from: buckets[i]
          })
        }
        else {
          this.learningState[buckets[i+1]].push(card)
          this.lastAction.push({
            to: buckets[i+1],
            from: buckets[i]
          })
        }
      }
      else if (value) {
        this.learningState[buckets[i+1]].push(card)
        this.lastAction.push({
          to: buckets[i+1],
          from: buckets[i]
        })
      }
      else {
        this.learningState[buckets[i]].push(card)
        this.lastAction.push({
          to: buckets[i],
          from: buckets[i]
        })
      }

    },

    setStage() { //used to track time and set stage
      if (this.learningState.assess.length > 0) {

        this.detectTranstion(this.stage, "assess")
        //set stage
        this.stage = "assess"
      }
      else if (this.learningState.learn.length > 0) {
        //track times

        this.detectTranstion(this.stage, "learn")

        //set stage

        this.stage = "learn"
      }
      else if (this.learningState.review.length > 0) {
        //track time

        this.detectTranstion(this.stage, "review")
        //set stage

        this.stage = "review"
      }
      else if (this.learningState.review.length == 0) {
        //track time
        this.detectTranstion(this.stage, "complete")
        //set stage
        this.stage = "complete"
        //record data

        //this.DBrecordDeckTermination()
      }
    },
    detectTranstion(from, to) {
      if (from == 'setup' && to == 'assess') {
        this.deckMetrics.timeAssessSet()
      }
      else if (from == 'assess' && to == 'learn') {
        this.deckMetrics.timeLearnSet()
      }
      else if (from == 'learn' && to == 'review') {
        this.deckMetrics.timeReviewSet()
      }
      else if (from == 'assess' && to == 'review') {
        this.deckMetrics.timeReviewSet()
      }
      else if (from == 'review' && to == 'assess') {
        this.deckMetrics.timeReviewClear()
      }
      else if (from == 'review' && to == 'learn') {
        this.deckMetrics.timeReviewClear()
      }
      else if (from == 'learn' && to == 'assess') {
        this.deckMetrics.timeLearnClear()
      }
      else if (to == 'complete') {
        this.deckMetrics.timeCompeteSet()


      }

    },
    skipReview() {
      this.stage = 'complete'
      this.deckMetrics.timeCompeteSet()
      this.deckMetrics.calculateCompletionMetrics()
      this.deckMetrics.DBrecordDeckTermination(this.learningState)
    },



    //ANALYTICS
    newLearningState(){
      return {
        assess: [],
        learn: [],
        review: [],
        know: []
      }
    },
    UItotalTimeSpent(seconds) {
      if (seconds < 60) {
        return seconds + " sec"
      }
      else {
        return Math.round(seconds/60) + " min"
      }
    },
    processHistory(history) {
      let r = []
      for (item in history) {
        r.push(item['deckMetrics']['assessScore'])
      }

    },
    DBlogPracticeProgress(seconds) {
      //safeguard to ensure computer being left open does not acount for excessive time
      let time
      if (seconds > 120) {
        time = 120
      } else {
        time = seconds
      }
      let date = moment().format('YYYY-MM-DD')
      let fields = {}
      fields[date] = {
        timeSeconds: firebase.firestore.FieldValue.increment(time),
        cards: firebase.firestore.FieldValue.increment(1)
      }
      firebase.firestore().collection('userDailyActivity')
      .doc(firebase.auth().currentUser.uid)
      .set(fields, {merge:true})
    },

    DBlogCardActivity() {
      //store date as documents by YYYY-MM-DD with hour objects
      let date = moment().format('YYYY-MM-DD')
      let hour = moment().format('HH')
      let log = {}
      let entry = {
        uid: firebase.auth().currentUser.uid,
        deck: this.deckId,
        card: this.currentCard,
        timestamp: new Date()
      }
      log[hour] = firebase.firestore.FieldValue.arrayUnion(entry)
      log['timestamp'] = new Date()
      firebase.firestore().collection('activityLog')
      .doc(date).set(log, {merge:true})
      firebase.firestore().collection('metrics')
      .doc('metrics').update({
        logs: firebase.firestore.FieldValue.increment(1)
      })
    },

    //Problems
    reportProblem() {
      this.$refs.problem.openDialog(this.content[this.currentCard])
    }

  }
}
</script>

<style>
.image-size {
  width: 100%;
  max-width: 500px;

}
#footer {
    position: fixed;
    bottom: 0;
    width: 60%;
    border: 1px solid grey;
    background: white;
    text-align: center;
}

</style>
